export enum MessageStatus {
  Pending = 0,
  Sent = 1,
  Failed = 2,
  Cancelled = 3,
}

export enum EmailType {
  PasswordReset = 10,
  Welcome = 20,
  PortalReservationWaitingList = 30,
  PortalReservationConfirmed = 40,
  PortalServiceReservationConfirmed = 50,
  AdminReservationWaitingList = 60,
  AdminReservationConfirmed = 70,
  AdminServiceReservationConfirmed = 80,
  AdminServiceReservationUpdated = 90,
  WaitingListSpotOpened = 100,
  AppointmentReminder = 110,
  FrontendErrorNotification = 120,
  StudioReservationNotification = 130,
  ReminderReport = 140,
  PrepaymentRequired = 150,
  FormCompletionRequired = 160,
  VerificationCode = 170,
  Invoice = 180,
  InvoiceOverdueWarning = 190,
  InvoiceOverdueReport = 200,
  MassEmail = 210,
  ReminderDigest = 290,
  ClientFormRequest = 360,
}

export const emailTypeOptions: { id: number; name: string }[] = [
  { id: EmailType.PasswordReset, name: "Смяна на парола" },
  { id: EmailType.Welcome, name: "Добре дошли" },
  { id: EmailType.PortalReservationWaitingList, name: "Резервация в изчакващи (портал)" },
  { id: EmailType.PortalReservationConfirmed, name: "Потвърдена резервация (портал)" },
  { id: EmailType.PortalServiceReservationConfirmed, name: "Потвърдена резервация за услуга (портал)" },
  { id: EmailType.AdminReservationWaitingList, name: "Резервация в изчакващи (администратор)" },
  { id: EmailType.AdminReservationConfirmed, name: "Потвърдена резервация (администратор)" },
  { id: EmailType.AdminServiceReservationConfirmed, name: "Потвърдена резервация за услуга (администратор)" },
  { id: EmailType.AdminServiceReservationUpdated, name: "Актуализирана резервация за услуга (администратор)" },
  { id: EmailType.WaitingListSpotOpened, name: "Освободено място в листа" },
  { id: EmailType.AppointmentReminder, name: "Напомняне за час" },
  { id: EmailType.StudioReservationNotification, name: "Известие за резервация" },
  { id: EmailType.PrepaymentRequired, name: "Изисква се предплащане" },
  { id: EmailType.FormCompletionRequired, name: "Изисква се попълване на форма" },
  { id: EmailType.ClientFormRequest, name: "Изпратена форма за попълване" },
  { id: EmailType.VerificationCode, name: "Код за потвърждение" },
  { id: EmailType.MassEmail, name: "Масов имейл" },
];

export interface IEmailLogModel {
  id: number;
  index: number;
  receiverName?: string;
  receiverEmail: string;
  subject?: string;
  status: MessageStatus;
  createdOn: string;
  sentOn?: string;
  errorMessage?: string;
}

export interface IEmailLogDetailModel {
  id: number;
  receiverEmail: string;
  subject?: string;
  compiledBody: string;
  status: MessageStatus;
  errorMessage?: string;
}

export interface IPaginatedResponse<T> {
  items: T[];
  totalCount: number;
  page: number;
  pageSize: number;
}
